const AdminLayout = () => import(/* webpackChunkName: "admin-layout" */ '@/layouts/AdminLayout')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard')
const ManageMenuEdit = () => import(/* webpackChunkName: "manage-menu-edit" */ '@/views/ManageMenuEdit')
const Pages = () => import(/* webpackChunkName: "pages" */ '@/views/Pages')
const Galerija = () => import(/* webpackChunkName: "galerija" */ '@/views/Galerija')
const GalerijaAlbum = () => import(/* webpackChunkName: "galerija-album" */ '@/views/GalerijaAlbum')
const Slider = () => import(/* webpackChunkName: "slider" */ '@/views/Slider')
const ManagePage = () => import(/* webpackChunkName: "manage-page" */ '@/views/ManagePage')
const Materijali = () => import(/* webpackChunkName: "materijali" */ '@/views/Materijali')
const MaterijalEdit = () => import(/* webpackChunkName: "materijali" */ '@/views/MaterijalEdit')
const MaterijalPreview = () => import(/* webpackChunkName: "materijali" */ '@/views/MaterijalPreview')

export default [
  {
    path: '/preview',
    name: 'MaterijalPreview',
    component: MaterijalPreview
  },
  {
    path: '/',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'manage-menu/add',
        name: 'ManageMenuAdd',
        component: ManageMenuEdit
      },
      {
        path: 'manage-menu/edit/:id',
        name: 'ManageMenuEdit',
        component: ManageMenuEdit
      },
      {
        path: 'pages',
        name: 'Pages',
        component: Pages
      },
      {
        path: 'add-page',
        name: 'AddPage',
        component: ManagePage
      },
      {
        path: 'edit/:id',
        name: 'EditPage',
        component: ManagePage
      },
      {
        path: 'materijali',
        name: 'Materijali',
        component: Materijali
      },
      {
        path: 'materijali/:materialId',
        name: 'MaterijalEdit',
        component: MaterijalEdit
      },
      {
        path: 'galerija',
        name: 'Galerija',
        component: Galerija
      },
      {
        path: 'galerija/:id',
        name: 'GalerijaAlbum',
        component: GalerijaAlbum
      },
      {
        path: 'slider',
        name: 'Slider',
        component: Slider
      }
    ]
  }
]
